import { Directive, ElementRef, Renderer2, OnInit, inject } from '@angular/core';
import { ClipboardPermissionService } from '../services/clipboard-permission-service';

@Directive({
  selector: '[appClipboardPermission]',
})
export class ClipboardPermissionDirective implements OnInit {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);
  private clipboardPermissionService = inject(ClipboardPermissionService);

  async ngOnInit() {
    const canRead = await this.clipboardPermissionService.checkPermission();
    if (!canRead) {
      this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
    }
  }
}
